import Request from './request'

const ServerInstances  = {
  getServerInstanceList (params, callback) {
    Request.get('server-instances/index', params).then(callback).catch(this.bad_answer)
  },
  getServerInstance (id, callback) {
    Request.get('server-instances/view/' + id).then(callback).catch(this.bad_answer)
  },
  updateServerInstance (id, params, callback) {
    Request.post('server-instances/update/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  addServerInstance (params, callback) {
    Request.post('server-instances/instance', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getServerInstanceGroups (params, callback) {
    Request.get('server-instances/groups', params).then(callback).catch(this.bad_answer)
  },
  createServerInstanceGroup (params, callback) {
    Request.post('server-instances/create-group', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}

export default ServerInstances
